import React, { lazy, Suspense, Component } from "react";
import { Route, Switch, withRouter, Redirect } from "react-router-dom";
import { connect } from "react-redux";
import axios from './axios-api';
//import asyncComponent from "./hoc/asyncComponent/asyncComponent";

import Layout from "./hoc/Layout/Layout";
//import BurgerBuilder from './containers/BurgerBuilder/BurgerBuilder';
import Logout from "./containers/Auth/Logout/Logout";
import Aux1 from './hoc/Aux1/Aux1';
import * as actions from "./store/actions/index";
import CacheBuster from './CacheBuster';

//import Dashboard from "./components/Dashboard/Dashboard";

const Booking = lazy(() => import("./components/Booking/Booking"));
const Dashboard = lazy(() => import("./components/Dashboard/Dashboard"));
const Auth = lazy(() => import("./containers/Auth/Auth"));
const Rooms = lazy(() => import('./containers/Rooms/Rooms_C'));
const Calendar = lazy(() => import('./components/Calendar/Calendar'));
const Checkout = lazy(() => import("./components/Checkout/Checkout"))
const Receipt = lazy(() => import('./containers/Receipt/Receipt_C'));
const OneTimeNiyaz = lazy(() => import('./containers/OneTimeNiyaz/OneTimeNiyaz_C'));
const Chalisa = lazy(() => import('./components/Chalisa/Chalisa'));
const Khidmat = lazy(() => import('./containers/Khidmat/Khidmat_C'));
const Mannat = lazy(() => import('./components/Mannat/Mannat'));
const Faiz = lazy(() => import('./components/Faiz/Faiz'));
const Laundry = lazy(() => import('./components/Laundry/Laundry'));
const HouseKeeping = lazy(() => import('./containers/HouseKeeping/HouseKeeping_C'));
const TravelHistory = lazy(() => import('./containers/TravelHistory/TravelHistory_C'));
const Feedback = lazy(() => import('./components/Feedback/Feedback'));
const Tools = lazy(() => import('./components/Tools/Tools'));
const Reports = lazy(() => import('./components/Reports/Reports'));
const DashboardMgr = lazy(() => import('./components/DashboardMgr/DashboardMgr'));
const Launch = lazy(() => import('./components/Launch/Launch'));
const TempRoute = lazy(() => import('./components/Navigation/TopHeader/TempRoute'));
const Kiosk = lazy(() => import('./containers/Kiosk/Kiosk_C'));
const BulkToken = lazy(() => import('./components/BulkToken/BulkToken'))

const windowUrl = window.location.hash;
if(windowUrl.includes("token2"))
{
    const url = windowUrl.replace("#/?id","")
    const id = url.substring(
      url.indexOf("=") + 1, 
      url.lastIndexOf("&")
  );
    let sp = url.replace(id,"");
    sp = sp.replace("=&token2=","");

    localStorage.setItem('tempuser', id);
    localStorage.setItem('temptoken', sp);
}

const semverGreaterThan = (versionA, versionB) => {
  const versionsA = versionA.split(/\./g);

  const versionsB = versionB.split(/\./g);
  while (versionsA.length || versionsB.length) {
    const a = Number(versionsA.shift());

    const b = Number(versionsB.shift());
    // eslint-disable-next-line no-continue
    if (a === b) continue;
    // eslint-disable-next-line no-restricted-globals
    return a > b || isNaN(b);
  }
  return false;
};

class App extends Component {
  componentDidMount() {
    this.props.onTryAutoSignup();
  }

  render() {
    let routes = (
      <Suspense
        fallback={
          <div className="loader h-100">
            <div className="d-flex justify-content-center align-items-center h-100">
              <div className="spinner-border" role="status">
                <span className="sr-only">Loading...</span>
              </div>
            </div>
          </div>
        }
      >
        <Switch>
          <Route path="/auth" component={Auth} />
          <Route path="/" exact component={Auth} />
          <Redirect to="/" />
        </Switch>
      </Suspense>
    );

    if (this.props.isAuthenticated) {
      routes = (
        <Suspense
          fallback={
            <div className="loader h-100">
              <div className="d-flex justify-content-center align-items-center h-100">
                <div className="spinner-border" role="status">
                  <span className="sr-only">Loading...</span>
                </div>
              </div>
            </div>
          }
        >
          <Switch>
            <Route exact path="/" component={Launch} />
            <Route path="/Dashboard" component={Dashboard} />
            <Route path="/Booking" component={Booking} />
            <Route path="/Rooms" component={Rooms} />
            <Route path="/Calendar" component={Calendar} />
            <Route path="/Checkout" component={Checkout} />
            <Route path="/logout" component={Logout} />
            <Route path="/Onetimeniyaz" component={OneTimeNiyaz} />
            <Route path="/Receipt" component={Receipt} />
            <Route path="/OneTimeNiyaz" component={OneTimeNiyaz} />
            <Route path="/Chalisa" component={Chalisa} />
            <Route path="/Khidmat" component={Khidmat} />
            <Route path="/Mannat" component={Mannat} />
            <Route path="/Faiz" component={Faiz} />
            <Route path="/Laundry" component={Laundry} />
            <Route path="/HouseKeeping" component={HouseKeeping} />
            <Route path="/TravelHistory" component={TravelHistory} />
            <Route path="/Feedback" component={Feedback} />
            <Route path="/Tools" component={Tools} />
            <Route path="/Reports" component={Reports} />
            <Route path="/DashboardMgr" component={DashboardMgr} />
            <Route exact path="/Launch" component={Launch} />
            <Route exact path="/Temp" component={TempRoute} />
            <Route exact path="/Kiosk" component={Kiosk} />
            <Route exact path="/BulkToken" component={BulkToken} />
            <Route path="**" render={
                () => (
                    <article>
                        <h1 className="text-danger">No Route Configured!</h1>
                        <h4 className="text-danger">Please check your Route Configuration</h4>
                    </article>
                )
            } />
          </Switch>
        </Suspense>
      );
    }

    return (
      
      <Aux1>
        <CacheBuster>
        {() => {

              fetch(`/meta.json?${new Date().getTime()}`, { cache: 'no-cache' })
              .then((response) => response.json())
              .then((meta) => {
                const latestVersion = meta.version;
                const currentVersion = global.appVersion;
                global.metaVersion = latestVersion;
               
                if(latestVersion !== currentVersion)
                {
                  const shouldForceRefresh = semverGreaterThan(latestVersion, currentVersion);

                  if (shouldForceRefresh) {
                    console.log(`We have a new version - ${latestVersion}. Should force refresh`);
                    console.log('Clearing cache and hard reloading...')
                    
                  if (window.caches != undefined) {
                
                    caches.keys().then(async function(names) {
                      await Promise.all(names.map(name => caches.delete(name)));
                      });
                  }

                  // delete browser cache and hard reload
                  window.location.reload(true);
                    
                  } else {
                    console.log(`You already have the latest version - ${latestVersion}. No cache refresh needed.`);
                    
                  }
              }
              });
          
          return (
           
              <Layout>{routes}</Layout>
            
          );
        }}
      </CacheBuster>
        
      </Aux1>
    );
  }
}

const mapStateToProps = state => {
  return {
    isAuthenticated: state.auth.token !== null
  };
};

const mapDispatchToProps = dispatch => {
  return {
    onTryAutoSignup: () => dispatch(actions.authCheckState())
  };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(App));
